"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPassDesign = isPassDesign;
function isPassDesign(content) {
    if (typeof content !== 'object' || content === null)
        return false;
    const c = content;
    return (typeof c.style === 'string' &&
        typeof c.images === 'object' &&
        c.images !== null &&
        typeof c.fields === 'object' &&
        c.fields !== null &&
        !('tripId' in c) &&
        !('flight' in c));
}
//# sourceMappingURL=isPassDesign.js.map